"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _appstatus = require("../../../../state/actions/appstatus");

var _modalstatus = require("../../../../state/actions/modalstatus");

var _button = _interopRequireDefault(require("./button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// actions
// component

/* ========== ~~~~~~~~~~ BUTTON: PARENT ~~~~~~~~~~ ========== */
// map state


var mapStateToProps = function mapStateToProps(_ref) {
  var appStatus = _ref.appStatus;
  return {
    currentPage: appStatus.currentPage,
    editMode: appStatus.editMode
  };
}; // map actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    moveToPage: function moveToPage(location) {
      dispatch((0, _appstatus.updatePageDetails)(location));
      dispatch((0, _appstatus.changePage)(location));
    },
    displayModal: function displayModal(isVisible, contentToDisplay, showCloseButton) {
      return dispatch((0, _modalstatus.displayModal)(isVisible, contentToDisplay, showCloseButton));
    }
  };
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_button.default);

exports.default = _default;